import { IconState } from "@components/molecules/IconUtils";
import { useState } from "react";
const useFavoriteState = (isFavorite?: boolean) => {
  const [favoriteIconState, setFavoriteIconState] = useState(
    IconState.Unselected
  );
  const [favoriteMenuOpen, setFavoriteMenuOpen] = useState(false);

  const handleFavoritesPressIn = () => {
    setFavoriteIconState(IconState.Pressed);
  };

  const handleFavoritesPressOut = () => {
    if (!favoriteMenuOpen) {
      setFavoriteIconState(IconState.Unselected);
    } else {
      setFavoriteIconState((prevState) =>
        prevState === IconState.Pressed ? IconState.Selected : prevState
      );
    }
  };

  const handleFavoritesPress = () => {
    if (favoriteMenuOpen) {
      setFavoriteMenuOpen(false);
      setFavoriteIconState(IconState.Unselected);
    } else {
      setFavoriteIconState(IconState.Selected);
    }
  };

  const getFavoriteIconBackgroundColor = (theme: any) => {
    switch (favoriteIconState) {
      case IconState.Selected:
        return theme["over-03"];
      case IconState.Pressed:
        return theme["over-03"];
      default:
        return theme["over-02"];
    }
  };

  const getFavoriteIconColor = (theme: any) => {
    switch (favoriteIconState) {
      case IconState.Selected:
        return isFavorite ? theme["error-05"] : theme["core-04"];
      case IconState.Pressed:
        return isFavorite ? theme["error-05"] : theme["core-04"];
      default:
        return isFavorite ? theme["core-06"] : theme["core-06"];
    }
  };

  return {
    favoriteIconState,
    setFavoriteIconState,
    favoriteMenuOpen,
    setFavoriteMenuOpen,
    handleFavoritesPressIn,
    handleFavoritesPressOut,
    handleFavoritesPress,
    getFavoriteIconBackgroundColor,
    getFavoriteIconColor,
  };
};

export default useFavoriteState;
